import axios from 'axios';

export default axios.create({
  baseURL: window.location.origin + '/' + window.location.pathname.split('/').slice(0,-1).join('/') + '/',
  crossDomain: true,
  headers: {
	'Content-Type': 'application/x-www-form-urlencoded',
	//"Access-Control-Allow-Origin": "*"
    //'Authorization': 'Bearer ' + localStorage.token
  }
})
